import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import _, { isNull } from 'lodash';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

import FormTitle from '../components/setSendData/FormTitle';
import NameAndAccountData from '../components/setSendData/NameAndAccountData';
import ExcelData from '../components/setSendData/ExcelData';
import CreateFields from '../components/setSendData/CreateFields';
import EmailTemplate from '../components/setSendData/EmailTemplate';
import DownloadReportModal from '../components/setSendData/DownloadReportModal';
import SendTime from '../components/setSendData/SendTime';
import EmailData from '../components/setSendData/EmailData';
import ButtonReportData from '../components/setSendData/ButtonReportData';
import ButtonSendData from '../components/setSendData/ButtonSendData';
import NoAdAccountPage from '../components/setSendData/NoAdAccountPage';
import { SEND_TIME_DATA, handleBiweeklyStart, handleEmailRemainbudget } from '../components/setSendData/data/emailConstants';

import LineCampaignData from '../components/setSendData/line/LineCampaignData';
import LineFieldsData from '../components/setSendData/line/LineFieldsData';
import LineDateRangeEdit from '../components/setSendData/line/LineDateRangeEdit';

import ModalComponent from '../components/modal/ModalComponent';
import { MODAL_CREATE_REPORT } from '../components/modal/constants';
import Loading from '../components/loading/Loading';
import { INPUT_ERROR_MSG, DOWNLOAD_ERROR_MSG, checkLineForm, checkLineDownloadForm } from '../components/formData/lineValidateForm';
import { checkReportForm, checkDateRangeForm, checkExcelNaming } from '../components/formData/formData';
import { BoxModalAlert } from '../components/customComponent';

import * as basicConstants from '../constants/basic';
import * as urlConstants from '../constants/url';
import * as alertConstants from '../constants/alertMsg';

import { requestKey } from '../api/api';
import { apiList, getCancelData } from '../api/callAPI';

import useUser from '../hook/useUser';
import useGlobalStatus from '../hook/useGlobalStatus';
import useCancel from '../hook/useCancel';
import useLineFieldsData from '../hook/useLineFieldsData';
import useColorSystem from '../hook/useColorSystem';

import {
  excelSheets,
  origiTargetName,
  generalData,
  allFixedFields,
  customData
} from '../utils/LineFieldsDefined';

import { formatDate, compareAscDate, formatDate2, formatDate3, handleDateRange } from '../utils/date';
import { scrollToAnchor } from '../utils/commonUtils';


const media = 'LINE';
const maxFieldsIndexNumber = 16;

const getCustomFields = (currentFields) => {
  const filterCustomFields = _.filter(currentFields, f => f.type === 'CUSTOM');
  const customFields = _.filter(filterCustomFields, f => f.cid === null);
  return [{
    category: 'custom',
    name: '自定義指標',
    child: customFields
  }]
}

const LineCreateData = (props) => {
  const history = useHistory();
  const intl = useIntl();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const { currentActiveData, setCurrentActiveData, locale, setLocale, entryPath, setEntryPath, setModalContent, setIsModalOpen, modalData, setModalData, handleAlertMsgSettings } = useGlobalStatus();
  const { cancelData, setCancelData } = useCancel();

  const [currentTab, setCurrentTab] = useState(0);
  const [cidList, setCidList] = useState([]);
  const [selectedAdAccounts, setSelectedAdAccounts] = useState([]);
  const [campaignList, setCampaignList] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState([]);

  const [reportName, setReportName] = useState('');
  const [dateRange, setDateRange] = useState({ startSendDate: null, endSendDate: null });
  const [reportDateRange, setReportDateRange] = useState({ startReportDate: null, endReportDate: null });

  const [reportLanguage, setReportLanguage] = useState("CHINESE");
  const [sendTimeData, setSendTimeData] = useState(SEND_TIME_DATA);

  const [emailList, setEmailList] = useState([]);
  const [emailString, setEmailString] = useState();
  const [emailTemplateType, setEmailTemplateType] = useState(basicConstants.EMAIL_TEMPLATE_COVERSION_CAMPAIGN);
  const [emailTemplatePrev, setEmailTemplatePrev] = useState({});
  const [emailTemplateCurrent, setEmailTemplateCurrent] = useState({});
  const [emailRemainbudget, setEmailRemainbudget] = useState(true);

  const [excelSheetSelected, setExcelSheetSelected] = useState(["LINE_DAILY", "LINE_CREATIVE", "LINE_AUDIENCE", "LINE_GENDER", "LINE_AGE"]);

  const [campaignGoalsSelected, setCampaignGoalsSelected] = useState([]);
  const [currentSheetName, setCurrentSheetName] = useState("");
  const [currentSheetOrigiName, setCurrentSheetOrigiName] = useState("");
  const [selectedExcelIndex, setSelectedExcelIndex] = useState(null);
  const [getCampaignTarget, setGetCampaignTarget] = useState([]);

  const [
    lineDefinition,
    // generalData,
    // allFixedFields
  ] = useLineFieldsData();

  const [origiCustomData, setOrigiCustomData] = useState([]);
  const [selectedCustomFields, setSelectedCustomFields] = useState([]);
  const [allDisplayFields, setAllDisplayFields] = useState([]);
  const [allUpdatefields, setAllUpdatefields] = useState([]); //控制上傳至伺服器的欄位語言
  const [selectedGeneralFields, setSelectedGeneralFields] = useState([]);
  const [currentSheetSelectFields, setCurrentSheetSelectFields] = useState([]);
  const [currenOptionFields, setCurrenOptionFields] = useState(null);
  const [updateSortFields, setUpdateSortFields] = useState([]); //已選擇的所有欄位排序

  const [selectedOptionFields, setSelectedOptionFields] = useState([]);
  const currentActiveDataWithCustomFields = getCustomFields(currentActiveData.fields);
  const [inputErrorMsg, setInputErrorMsg] = useState(INPUT_ERROR_MSG);
  const [downloadInputErrorMsg, setdownloadInputErrorMsg] = useState(DOWNLOAD_ERROR_MSG);
  const [anchorEl, setAnchorEl] = useState(null);
  const [modalName, setModalName] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingBox, setLoadingBox] = useState(false);
  const [sendList, setSendList] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [downloadOrSend, setDownloadOrSend] = useState('');
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();


  const getSelectedCidData = (allCidList, selectedCidList) => {
    return _.filter(allCidList, el => _.findIndex(selectedCidList, c => c.adAccountId === el.adAccountId) > -1);
  }

  useEffect(() => {
    if (!userData) return;

    let call;

    if (cancelData) {
      cancelData.cancel(alertConstants.CANCEL_REQUEST);
    }

    call = getCancelData();

    apiList.apiGetOwnedAdAccount({
      page: 0,
      size: 100000
    }, call.token)
      .then(res => {
        if (res.message && res.message === alertConstants.CANCEL_REQUEST) return;
        if (res.status === 200) {
          setCidList(res.data.result.content.filter((el) => el.media === 'LINE'));
          if (entryPath === urlConstants.PAGE_LINE_CREATE_DATA) {
            setSelectedAdAccounts([]);
          } else {
            setSelectedAdAccounts(getSelectedCidData(res.data.result.content, currentActiveData.facebookAccounts));
          }
          setIsLoading(false);
        } else if (res.status === 401) {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else {
          setAlertMsg(alertConstants.ERROR_SYSTEMCONNECT);
        }
      })
  }, [userData])

  //顯示廣告目標
  useEffect(() => {
    if (!getCampaignTarget.length) return;

    if (entryPath === urlConstants.PAGE_LINE_CREATE_DATA) {
      let allCampaignGoals = campaignGoalsList.map((el) => el.campaignGoalEng);
      setCampaignGoalsSelected(allCampaignGoals);
    }
  }, [entryPath, getCampaignTarget])

  useEffect(() => {
    if (entryPath.includes('edit')) {
      setCampaignGoalsSelected(currentActiveData.campaignList);
    }
  }, [entryPath, currentActiveData])

  //顯示欄位
  useEffect(() => {
    if (entryPath.includes('create')) {
      setAllDisplayFields(allFixedFields);
    } else {
      setAllDisplayFields(_.concat(currentActiveDataWithCustomFields, allFixedFields));
    }
  }, [entryPath, selectedAdAccounts])

  //儲存寄送設定
  useEffect(() => {
    if (downloadOrSend === 'downloadData') {
      return;
    } else if (downloadOrSend === 'sendData') {
      handleStoreReport();
    }
  }, [downloadOrSend])

  //重新整理後返回MEDIA_MENU
  useEffect(() => {
    if (entryPath === '') {
      setIsModalOpen(false);
      history.push(urlConstants.PAGE_MEDIA_MENU);
    }
  }, [entryPath])

  //改變帳號時清空廣告目標、分頁與欄位
  useEffect(() => {
    setGetCampaignTarget([]);
    setCampaignGoalsSelected([]);
    setCurrentSheetName("");
    setSelectedExcelIndex(null);
    setCurrentSheetSelectFields([]);
    setCurrenOptionFields(null);

    if (selectedAdAccounts.length !== 0) {
      fetchGetTarget();
    }
  }, [selectedAdAccounts])

  //自訂欄(顯示分類)
  const customDisplayFields = Array.from(new Set(origiCustomData
    .map((s) => s.cidname)))
    .map((lab, index) => {
      return {
        category: lab,
        name: "自訂轉換欄",
        child: origiCustomData.filter((item) => item.cidname === lab)
          .map((edition, index) => {
            const formatExpression = edition.id.replace(/\s+/g, '');
            return {
              name: `${edition.name}(自訂欄)`,
              expression: `${formatExpression}_custom`,
              format: 'DEFAULT',
              type: 'CUSTOM',
              sheet: [],
              cidname: edition.cidname,
              cid: edition.cid,
              indexNumber: maxFieldsIndexNumber + 1 + index
            }
          })
      }
    })

  //自訂欄(回傳格式)
  const customFieldsData = origiCustomData.map((edition, index) => {
    const formatExpression = edition.id.replace(/\s+/g, '');
    return {
      name: `${edition.name}(自訂欄)`,
      expression: `${formatExpression}_custom`,
      format: 'DEFAULT',
      type: 'CUSTOM',
      sheet: [],
      cidname: edition.cidname,
      cid: edition.cid,
      indexNumber: maxFieldsIndexNumber + 1 + index
    }
  })

  useEffect(() => {
    changeDisplayCustomFields();
  }, [origiCustomData, entryPath]);

  const changeDisplayCustomFields = () => {
    const cloneAllDisplayFields = JSON.parse(JSON.stringify(allDisplayFields));
    const clearCustomFields = cloneAllDisplayFields.filter(el => el.name !== '自訂轉換欄');
    const addCustomConversions = customDisplayFields.concat(clearCustomFields);

    setAllDisplayFields(addCustomConversions);
  }

  const changeSelectedCustomFields = () => {
    setSelectedCustomFields(customFieldsData);
  }

  const campaignGoalsList = getCampaignTarget.map((el) => {
    const goalIndex = _.findIndex(origiTargetName, c => c.campaignGoalEng === el);

    return {
      campaignGoalName: origiTargetName[goalIndex].campaignGoalName,
      campaignGoalEng: el
    }
  })

  const fetchGetTarget = () => {
    setLoadingBox(true);
    const adAccountId = selectedAdAccounts.map(el => el.adAccountId);
    apiList.lineGetTarget({
      cid: adAccountId.toString()
    })
      .then(res => {
        if (res.status === 200) {
          if (entryPath === urlConstants.PAGE_LINE_CREATE_DATA) {
            if (res.data.result === null || !res.data.result.length) {
              setGetCampaignTarget([]);
              setModalContent({ ...MODAL_CREATE_REPORT['checkNoTarget'], media: media });
              setIsModalOpen(true);
            } else {
              setGetCampaignTarget(res.data.result);
              setCampaignGoalsSelected(res.data.result);
            };

          } else if (entryPath === urlConstants.PAGE_LINE_EDIT_DATA) {
            if (res.data.result === null || !res.data.result.length) {
              setGetCampaignTarget([]);
            } else {
              setGetCampaignTarget(res.data.result);

              const currentCid = currentActiveData.facebookAccounts.map((el) => el.adAccountId);
              const selectedCid = selectedAdAccounts.map((el) => el.adAccountId);
              const matchCid = _.intersection(currentCid, selectedCid);

              if (currentCid.length === matchCid.length) {
                setCampaignGoalsSelected(currentActiveData.campaignList);
              } else {
                setCampaignGoalsSelected(res.data.result);
              }
            }
          }

          setLoadingBox(false);

        } else if (res.status === 401) {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else {
          alert(alertConstants.ERROR_SYSTEMCONNECT);
        }
      })
  }

  //廣告活動(回傳格式)
  const campaignData = selectedCampaign.map((edition) => {
    return {
      cid: edition.cid,
      cidname: edition.cidname,
      id: edition.id,
      name: edition.name
    }
  })

  const changeCampaignGoals = (e) => {
    const { name, checked } = e.target;

    if (checked) {
      setCampaignGoalsSelected(prev => [...prev, name]);
    } else {
      setCampaignGoalsSelected(prev => prev.filter(el => el !== name));
      setCurrentSheetName('');
      setSelectedExcelIndex(null);
    }
  }

  const handleFieldsLanguage = () => {
    const allFields = _.concat(selectedGeneralFields, selectedCustomFields);

    const updateFields = allFields && allFields
      .sort((a, b) => {
        if (a.indexNumber === null) return 1;
        if (b.indexNumber === null) return -1;
        return a.indexNumber - b.indexNumber;
      })
      .map((field, index) => ({
        ...field,
        name: reportLanguage === 'ENGLISH' ? (field.name_eng ? field.name_eng : field.name) : field.name,
        indexNumber: field.indexNumber != null ? index : allFields?.length + index
      }))

    setAllUpdatefields(updateFields);
  }

  const handleInput = (e) => {
    const { name, value } = e.target;
    if (name === 'reportName') {
      setReportName(value);
    }
    if (name === 'emailString') {
      setEmailString(value);
    }
  }

  //改變選擇欄位
  const changeDefinedFields = (e, field) => {
    const { checked } = e.target;
    const generalData = JSON.parse(JSON.stringify(selectedGeneralFields));
    const customData = JSON.parse(JSON.stringify(selectedCustomFields));
    const generalIndex = _.findIndex(generalData, (el) => el.expression === field.expression);
    const customIndex = _.findIndex(customData, (el) => el.expression === field.expression);

    const isGeneral = generalIndex > -1;
    const targetData = isGeneral ? generalData : customData;
    const targetIndex = isGeneral ? generalIndex : customIndex;

    if (checked) {
      if (targetIndex > -1) {
        const initSheet = targetData[targetIndex].sheet || [];
        targetData[targetIndex].sheet = initSheet.concat(currentSheetOrigiName);
        isGeneral ? setSelectedGeneralFields(targetData) : setSelectedCustomFields(targetData);

        setCurrentSheetSelectFields(prev => [
          ...prev, { ...field, sheet: initSheet.concat(currentSheetOrigiName) }
        ])
      }

    } else {
      if (targetIndex > -1) {
        _.pull(targetData[targetIndex].sheet, currentSheetOrigiName);
        isGeneral ? setSelectedGeneralFields(targetData) : setSelectedCustomFields(targetData);
      }
      const deletFields = currentSheetSelectFields.filter(el => el.expression !== field.expression);
      setCurrentSheetSelectFields(deletFields);
    }
  }

  //刪除欄位
  const handleDeleteFields = (e, field, type) => {
    setCurrenOptionFields(null);

    let generalData = JSON.parse(JSON.stringify(selectedGeneralFields));
    let customData = JSON.parse(JSON.stringify(selectedCustomFields));
    let displayData = JSON.parse(JSON.stringify(allDisplayFields));

    const generalIndex = _.findIndex(generalData, (el) => el.expression === field.expression);
    const customFieldsIndex = _.findIndex(customData, (el) => el.expression === field.expression);

    if (generalIndex > -1) {
      _.pull(generalData[generalIndex].sheet, currentSheetOrigiName)
      if (type === 'deleteField') {
        generalData = generalData.filter(el => !(el.expression === field.expression && el.type === 'CUSTOM' && !el.cid));
      }
      setSelectedGeneralFields(generalData);

    } else if (customFieldsIndex > -1) {
      _.pull(customData[customFieldsIndex].sheet, currentSheetOrigiName)
      setSelectedCustomFields(customData);
    }

    const deletFields = currentSheetSelectFields.filter(el => el.expression !== field.expression);
    setCurrentSheetSelectFields(deletFields);

    if (type === 'deleteField') {
      const updateFields = displayData.map(el => ({
        ...el,
        child: el.category === 'custom' ? el.child.filter(child => child.expression !== field.expression) : el.child
      }));
      setAllDisplayFields(updateFields);
    }
  }

  const handleModalDetail = (type) => {
    setOpenModal(true);

    if (type === 'create_custom_metric') {
      setModalName('create_custom_metric');
    }
  }

  //新增自定義指標
  const addCustomFields = (newFields, matchFields) => {
    const allSheet = origiTargetName.map(el => el.campaignGoalEng);
    newFields.sheet = allSheet;

    const updateFields = (origiFields, fieldsType) => {
      const cloneFields = JSON.parse(JSON.stringify(origiFields));
      const index = cloneFields.findIndex(el => el.expression === newFields.expression);

      // 顯示欄位新增自定義指標
      if (fieldsType === 'display') {
        const categoryIndex = cloneFields.findIndex(item => item.category === 'custom');

        if (categoryIndex !== -1) {
          const childIndex = cloneFields[categoryIndex].child.findIndex(item => item.expression === newFields.expression);
          //已存在的自定義指標就覆蓋，否則新增一欄
          childIndex !== -1 ? cloneFields[categoryIndex].child[childIndex] = newFields : cloneFields[categoryIndex].child.push(newFields);
        } else {
          cloneFields.unshift({
            category: 'custom',
            name: '自定義指標',
            child: [newFields]
          })
        }
      }

      // 已選欄位新增自定義指標
      if (fieldsType === 'general') {
        index !== -1 ? cloneFields[index] = newFields : cloneFields.push(newFields);
      }

      // 有設公式的指標自動打勾
      const updateFields = cloneFields.map(field => {
        if (matchFields.includes(field.expression)) {
          field.sheet = allSheet
        }
        return field;
      })

      return updateFields;
    }

    setAllDisplayFields(updateFields(allDisplayFields, 'display'));
    setSelectedGeneralFields(updateFields(selectedGeneralFields, 'general'));
    setSelectedCustomFields(updateFields(selectedCustomFields, 'conversions'));
    setCurrentSheetName("");
    setSelectedExcelIndex(null);
  }

  const validateReportForm = (isDownload) => {
    const formData = {
      reportName,
      fbAdAccounts: selectedAdAccounts,
      excelSheet: excelSheetSelected,
      selectFields: _.concat(selectedGeneralFields, selectedCustomFields),
      optionFieldName: _.concat(selectedGeneralFields, selectedCustomFields),
      reportType: sendTimeData,
      emailList,
      emailTemplate: emailTemplateCurrent,
      emailTemplateType,
      dateRange,
      isDownload,
      campaignGoalsSelected,
    };

    return checkReportForm(formData, media);
  }

  const clickDownloadReport = () => {
    handleFieldsLanguage();
    setDownloadOrSend('downloadData');
    const { errorMsg, isErrorStatue } = validateReportForm(true);
    setInputErrorMsg({ ...errorMsg, reportDateRange: '' });

    if (isErrorStatue) {
      if (errorMsg.reportName || errorMsg.fbAdAccounts) {
        scrollToAnchor('scrollTop');
      }
      return;
    }

    setModalName('setting_report_dateRange');
    setModalContent({ ...MODAL_CREATE_REPORT['chooseSaveReport'], media: media });
  }

  const clickUpdateReport = () => {
    handleFieldsLanguage();
    if (downloadOrSend === 'downloadData' || downloadOrSend === '') {
      setDownloadOrSend('sendData');
    } else if (downloadOrSend === 'sendData') {
      handleStoreReport();
    }
  }

  const prepareReportData = () => {
    const formatDateIfNotNull = date => date !== null ? formatDate(date) : null;
    return {
      "weeklyReportName": reportName,
      "startSendDate": null,
      "endSendDate": null,
      "sendDay": sendTimeData.weekday + 1,
      "sendTime": basicConstants.HOUR_LIST[sendTimeData.weektime],
      "monthly": sendTimeData.monthday + 1,
      "biweekly_day": sendTimeData.biWeekDay + 1,
      "biweekly_start": sendTimeData.reportType.includes('2') ? handleBiweeklyStart(currentActiveData, sendTimeData) : null,
      "reportType": sendTimeData.reportType.join(','),
      "facebookAdAccountIds": selectedAdAccounts.map(el => el.adAccountId),
      "toAddresses": emailList.filter(el => el !== ""),
      "mailMessageType": basicConstants.EMAIL_TEMPLATE_REACH,
      "mailMessageExtra": handleEmailRemainbudget(emailTemplateCurrent),
      "excelSheets": excelSheetSelected,
      "fields": allUpdatefields,
      "startReportDate": formatDateIfNotNull(reportDateRange.startReportDate),
      "endReportDate": formatDateIfNotNull(reportDateRange.endReportDate),
      "campaignList": campaignGoalsSelected,
      "conversionsType": campaignData.map((el) => el.id).toString()
      // "language": reportLanguage,
    }
  }

  const handleChooseSaveReport = (saveSettings) => {
    const errorMsg = checkDateRangeForm(reportDateRange);
    setInputErrorMsg({ reportDateRange: errorMsg });
    if (errorMsg) return;

    const storeReportData = prepareReportData();

    if (saveSettings === 'saveReport') {
      handleDownloadReport(storeReportData);
    } else {
      setModalContent({ ...MODAL_CREATE_REPORT['processingDownloadReport'], media: media });
      setIsModalOpen(true);
      setModalName('');
      downloadExternalReport(storeReportData);
    }
  }

  const handleDownloadReport = (storeReportData) => {
    if (entryPath.includes("create")) {
      createReport(storeReportData);
    } else if (entryPath.includes("edit")) {
      updateReport(storeReportData);
    }
  }

  const handleStoreReport = () => {
    const { isTab1Error, isTab2Error, errorMsg, isErrorStatue } = validateReportForm(false);
    setInputErrorMsg(errorMsg);

    if (isTab1Error) {
      scrollToAnchor('scrollTop');
      setCurrentTab(0);
    } else if (isTab2Error) {
      scrollToAnchor('scrollTop');
      setCurrentTab(1);
    }

    if (isErrorStatue) return;

    const storeReportData = prepareReportData();

    if (entryPath.includes("create")) {
      createReport(storeReportData);
    } else if (entryPath.includes("edit")) {
      updateReport(storeReportData);
    }
  }

  //1.createLineReport 
  const createReport = (createReportData) => {
    setModalName('');
    setIsLoading(true);

    apiList.createLineReport(createReportData)
      .then(res => {
        if (res.status === 200) {
          if (downloadOrSend === 'downloadData') {
            getSendList();
          } else if (downloadOrSend === 'sendData') {
            setIsLoading(false);
            setModalName('alert');
            setTimeout(() => {
              setModalName('');
              history.push(urlConstants.PAGE_LINE_SEND_LIST);
            }, 2000)
          }
        } else if (res.status === 500 || res.status === 400) {
          scrollToAnchor('scrollTop');
          alert(alertConstants.ERROR_CUSTOM_EXPRESSION);
          setCurrentSheetName("");
          setIsLoading(false);
        } else {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        }
      })
  }

  const fetchData = (cancelToken) => {
    let result;

    result = apiList.getLineReportList({
      page: 0,
      size: 10,
      sort: null,
      order: null
    }, cancelToken)

    result.then(res => {
      if (res.message && res.message === alertConstants.CANCEL_REQUEST) return;

      if (res.status === 200) {
        confirmReport(res.data.result.content);
      } else if (res.status === 401) {
        setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
        setUserData(false);
        history.push(urlConstants.PAGE_LOGIN);
      } else {
        alert(alertConstants.ERROR_SYSTEMCONNECT);
        history.push(urlConstants.PAGE_LINE_SEND_LIST)
      }
    })

  }

  const getSendList = () => {
    let call;

    if (cancelData) {
      cancelData.cancel(alertConstants.CANCEL_REQUEST);
    }

    call = getCancelData();
    setCancelData(call);

    fetchData(call.token);
  }

  //確認匯出報表
  const confirmReport = (sendList) => {
    setIsProcessing('downloadReport');

    if (entryPath === urlConstants.PAGE_LINE_CREATE_DATA) {
      setCurrentActiveData(sendList[0]);
    }
    setModalContent({ ...MODAL_CREATE_REPORT['confirmDownloadReport'], media: media });
    setModalData({ reportName });
    setIsModalOpen(true);
    setIsProcessing(false);
    setIsLoading(false);
  }

  //下載報表excel
  const downloadReport = () => {
    setIsProcessing('downloadReport');
    setEntryPath(urlConstants.PAGE_LINE_REDOWNLOAD);
    setCurrentSheetName("");
    setCurrenOptionFields(null);
    setdownloadInputErrorMsg({ reportDateRange: '' });

    // excel檔名不能有 [ ] < > : * ? | 
    const checkReportName = reportName.replace(/\[|]|<|>|:|\*|\?|\|/g, "");

    const dataRange = handleDateRange(reportDateRange.startReportDate, reportDateRange.endReportDate);

    const query = {
      weeklyReportId: currentActiveData.weeklyReportId,
      start_date: formatDate2(reportDateRange.startReportDate),
      end_date: formatDate2(reportDateRange.endReportDate),
      excel: currentSheetOrigiName
    }

    apiList.downloadLineReport(query)
      .then(res => {
        if (res.status === 201 || res.status === 200) {
          const contentType = res.headers['content-type'];
          const file = new Blob([res.data], { type: contentType });
          const url = URL.createObjectURL(file);
          const a = document.createElement('a');
          a.href = url;
          a.download = '【LINE報表】' + checkReportName + '_' + currentSheetName + '_' + dataRange + '.xlsx';
          a.click();
          window.URL.revokeObjectURL(url);

          setTimeout(() => {
            setIsModalOpen(false);
            setIsProcessing(false);
            setModalName("setting_report_dateRange");
          }, 2000)

        } else if (res.status === 401) {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          setIsModalOpen(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else if (res.status === 404) {
          setIsProcessing(false);
          setModalContent({ ...MODAL_CREATE_REPORT['downloadReportNoData'], media: media });
        } else if (res.status === 504) {
          setIsProcessing(false);
          setModalContent({ ...MODAL_CREATE_REPORT['downloadReportTimeOut'], media: media });
        } else {
          setIsModalOpen(false);
          setIsProcessing(false);
          alert(alertConstants.ERROR_SYSTEMCONNECT);
          history.push(urlConstants.PAGE_LINE_SEND_LIST)
        }
      })
  }

  const downloadExternalReport = (updateReportData) => {
    setIsProcessing('downloadReport');
    const reportMedia = intl.formatMessage({ id: "common.title.lineReport" });
    const updatedReportName = checkExcelNaming(reportName);
    const dataRange = handleDateRange(reportDateRange.startReportDate, reportDateRange.endReportDate);
    const fileName = `${reportMedia}${updatedReportName}_${currentSheetName}_${dataRange}.xlsx`;

    const params = {
      requestKey: requestKey,
      startDate: formatDate3(reportDateRange.startReportDate),
      endDate: formatDate3(reportDateRange.endReportDate),
      excel: currentSheetOrigiName
    }

    apiList.downloadLineExternalReport({ data: updateReportData, config: params })
      .then(res => {
        if (res.status === 201) {
          const contentType = res.headers['content-type'];
          const file = new Blob([res.data], { type: contentType });
          const url = URL.createObjectURL(file);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          setIsModalOpen(false);
          setTimeout(() => {
            setIsProcessing(false);
            history.push(urlConstants.PAGE_LINE_SEND_LIST)
          }, 2000)
        } else if (res.status === 401) {
          setIsModalOpen(false);
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else if (res.status === 404) {
          setIsProcessing(false);
          setModalContent({ ...MODAL_CREATE_REPORT['downloadReportNoData'], media: media });
          setIsModalOpen(true);
        } else {
          setIsModalOpen(false);
          setIsProcessing(false);
          handleAlertMsgSettings(true, { type: alertConstants.ALERT_TYPE.ERROR, msg: `${alertConstants.ERROR_SYSTEMCONNECT} ${res.status}` });
          history.push(urlConstants.PAGE_LINE_SEND_LIST)
        }
      })
  }

  //2.updateLineReport
  const updateReport = (updateReportData) => {
    setModalName('');
    setIsLoading(true);

    apiList.updateLineReport({ data: updateReportData, config: { weeklyReportId: currentActiveData.weeklyReportId } })
      .then(res => {
        if (res.status === 200) {
          setIsLoading(false);
          if (downloadOrSend === 'downloadData') {
            setModalContent({ ...MODAL_CREATE_REPORT['confirmDownloadReport'], media: media });
            setModalData({ reportName });
            setIsModalOpen(true);
          } else if (downloadOrSend === 'sendData') {
            setModalName('alert');
            setTimeout(() => {
              setModalName('');
              history.push(urlConstants.PAGE_LINE_SEND_LIST);
            }, 2000)
          }

        } else if (res.status === 500 || res.status === 400) {
          scrollToAnchor('scrollTop');
          alert(alertConstants.ERROR_CUSTOM_EXPRESSION);
          setCurrentSheetName("");
          setIsLoading(false);

        } else {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        }
      })
  }

  const handleModalSubmit = (data, type) => {
    switch (type) {
      case 'confirm_download_report':
        downloadReport();
        break;
      case 'download_report_time_out':
        downloadReport();
        break;
      case 'download_report_no_data':
      case 'download_report_time_out_close':
        setModalName("");
        setCurrentSheetName("");
        setIsModalOpen(false);
        break;
      case 'check_import_customfields':
        changeSelectedCustomFields();
        setIsModalOpen(false);
        break;
      case 'check_no_customfields':
      case 'check_import_campaign':
      case 'check_no_campaign':
      case 'check_no_target':
        setIsModalOpen(false);
        break;
      default:
        break;
    }
  }

  // console.log('generalData', generalData);
  // console.log('customFieldsData', customFieldsData);
  // console.log('Line_Fields', allUpdatefields);

  return (
    <>
      {
        userData.scopes.includes(basicConstants.AUTH_EDIT_REPORT) &&
        <>
          <Box
            id="scrollTop"
            sx={{
              width: { sm: '100%', md: '80%', lg: '70%' },
              margin: '0 auto 60px'
            }}
          >
            {
              cidList.length > 0 &&
              <>
                <FormTitle
                  media={"LINE"}
                  currentTab={currentTab}
                  setCurrentTab={setCurrentTab}
                  mainColor={mainColor}
                />

                <Box sx={{ overflow: 'hidden' }}>
                  <Box
                    sx={{
                      position: 'relative',
                      top: 0,
                      left: `-${currentTab * 100}%`,
                      display: 'flex',
                      justifyContent: 'flex-start',
                      width: '200%',
                      transition: 'left .5s'
                    }}
                  >
                    <Box id="basicData" sx={{ width: '100%', padding: '0 4px' }}>
                      <NameAndAccountData
                        media='LINE'
                        cidList={cidList}
                        selectedAdAccounts={selectedAdAccounts}
                        setSelectedAdAccounts={setSelectedAdAccounts}
                        reportName={reportName}
                        setReportName={setReportName}
                        handleInput={handleInput}
                        inputErrorMsg={inputErrorMsg}
                      />

                      <LineCampaignData
                        selectedAdAccounts={selectedAdAccounts}
                        getCampaignTarget={getCampaignTarget}
                        campaignList={campaignList}
                        setCampaignList={setCampaignList}
                        selectedCampaign={selectedCampaign}
                        setSelectedCampaign={setSelectedCampaign}
                        setModalName={setModalName}
                        setIsLoading={setIsLoading}
                        scrollToAnchor={scrollToAnchor}
                      />

                      <ExcelData
                        colorSystem={colorMedia}
                        excelSheets={excelSheets}
                        setExcelSheetSelected={setExcelSheetSelected}
                        inputErrorMsg={inputErrorMsg}
                        downloadInputErrorMsg={downloadInputErrorMsg}
                      />

                      <LineFieldsData
                        selectedAdAccounts={selectedAdAccounts}
                        handleModalDetail={handleModalDetail}
                        changeDefinedFields={changeDefinedFields}
                        inputErrorMsg={inputErrorMsg}
                        downloadInputErrorMsg={downloadInputErrorMsg}
                        handleDeleteFields={handleDeleteFields}
                        currentSheetName={currentSheetName}
                        setCurrentSheetName={setCurrentSheetName}
                        setCurrentSheetOrigiName={setCurrentSheetOrigiName}
                        selectedExcelIndex={selectedExcelIndex}
                        setSelectedExcelIndex={setSelectedExcelIndex}
                        allDisplayFields={allDisplayFields}
                        currentSheetSelectFields={currentSheetSelectFields}
                        setCurrentSheetSelectFields={setCurrentSheetSelectFields}
                        currenOptionFields={currenOptionFields}
                        setCurrenOptionFields={setCurrenOptionFields}
                        selectedGeneralFields={selectedGeneralFields}
                        setSelectedGeneralFields={setSelectedGeneralFields}
                        setOrigiCustomData={setOrigiCustomData}
                        selectedCustomFields={selectedCustomFields}
                        setSelectedCustomFields={setSelectedCustomFields}
                        customFieldsData={customFieldsData}
                        updateSortFields={updateSortFields}
                        setUpdateSortFields={setUpdateSortFields}
                        campaignGoalsSelected={campaignGoalsSelected}
                        changeCampaignGoals={changeCampaignGoals}
                        campaignGoalsList={campaignGoalsList}
                        setModalName={setModalName}
                        scrollToAnchor={scrollToAnchor}
                        setIsLoading={setIsLoading}
                        loadingBox={loadingBox}
                      />

                      <ButtonReportData
                        id="scrollDown"
                        colorSystem={colorMedia}
                        clickDownloadReport={clickDownloadReport}
                        setCurrentTab={setCurrentTab}
                        scrollToAnchor={scrollToAnchor}
                      />

                    </Box>

                    <Box id="pagesAndFields" sx={{ width: '100%', padding: '0 4px' }}>
                      <SendTime
                        media={media}
                        sendTimeData={sendTimeData}
                        setSendTimeData={setSendTimeData}
                        inputErrorMsg={inputErrorMsg}
                      />

                      <EmailData
                        media={media}
                        emailList={emailList}
                        setEmailList={setEmailList}
                        emailString={emailString}
                        setEmailString={setEmailString}
                        EmailTemplate={EmailTemplate}
                        emailTemplateCurrent={emailTemplateCurrent}
                        setEmailTemplateCurrent={setEmailTemplateCurrent}
                        emailTemplatePrev={emailTemplatePrev}
                        setEmailTemplatePrev={setEmailTemplatePrev}
                        emailTemplateType={emailTemplateType}
                        setEmailTemplateType={setEmailTemplateType}
                        emailRemainbudget={emailRemainbudget}
                        setEmailRemainbudget={setEmailRemainbudget}
                        inputErrorMsg={inputErrorMsg}
                        setInputErrorMsg={setInputErrorMsg}
                        handleInput={handleInput}
                        optionalFields={allDisplayFields.filter(el => el.name !== '自訂轉換欄' && el.name !== '自定義指標')}
                      />

                      <ButtonSendData
                        colorSystem={colorMedia}
                        setCurrentTab={setCurrentTab}
                        clickUpdateReport={clickUpdateReport}
                        url={urlConstants.PAGE_LINE_SEND_LIST}
                      />

                    </Box>

                  </Box>
                </Box>
              </>
            }
          </Box>
          {
            cidList.length === 0 && !isLoading &&
            <NoAdAccountPage
              colorSystem={colorMedia}
              setEntryPath={setEntryPath}
            />
          }
          {
            modalName === 'alert' &&
            <Modal open={modalName === 'alert'}>
              <BoxModalAlert>
                已儲存 <span style={{ color: mainColor }}>{reportName}</span> 寄送通知<br />
              </BoxModalAlert>
            </Modal>
          }
          {
            modalName === 'create_custom_metric' &&
            <CreateFields
              media='LINE'
              optionalFields={allDisplayFields}
              open={modalName === 'create_custom_metric'}
              handleClose={() => setModalName(false)}
              handleSave={addCustomFields}
              cidList={cidList}
              reportLanguage={reportLanguage}
            />
          }
          {/* 自訂走期下載報表 */}
          {
            modalName === 'setting_report_dateRange' &&
            <DownloadReportModal
              media={media}
              open={modalName === 'setting_report_dateRange'}
              reportDateRange={reportDateRange}
              setReportDateRange={setReportDateRange}
              inputErrorMsg={inputErrorMsg}
              isLoading={isProcessing}
              handleClose={() => setModalName(false)}
              handleChooseSaveReport={handleChooseSaveReport}
              campaignGoalsList={campaignGoalsList}
              campaignGoalsSelected={campaignGoalsSelected}
              setCurrentSheetName={setCurrentSheetName}
              setCurrentSheetOrigiName={setCurrentSheetOrigiName}
            />
          }
          <ModalComponent
            isLoading={isProcessing}
            handleModalSubmit={handleModalSubmit}
          />
        </>
      }
      <Loading isLoading={isLoading} content={alertConstants.TIP_DATA_LOADING} />
    </>
  )
}

export default LineCreateData;